/*  eslint-disable react-hooks/rules-of-hooks */
import { injectable } from 'inversify';
import { GlobalQueryParams } from './queryParams.interface';
import { globalQuerySelector, dispatchGlobalQuery } from './global.query.slice';
import { store } from '../store';

// GlobalQueryService manages shared global queryParam state.
@injectable()
export class GlobalQueryService {
  globalQuerySelector = globalQuerySelector;
  private dispatchGlobalQuery = dispatchGlobalQuery;

  dispatchQueryParams(queryParams: Partial<GlobalQueryParams>) {
    const validQueryParams = this.getValidGlobalQueryParams(queryParams);
    const usedQueryParams = this.removeUnusedQueryParams(validQueryParams);
    store.dispatch(this.dispatchGlobalQuery(usedQueryParams));
  }

  private getValidGlobalQueryParams = (
    queryParams: Partial<GlobalQueryParams>,
  ): GlobalQueryParams => {
    // TODO: use interface to make this update automatically when you add a queryParam
    return {
      selectedTeamId: queryParams.selectedTeamId,
      email: queryParams.email,
    };
  };

  // removes valid properties which are not set to allow merging in useQuerySync (otherwise an undefined property can overwrite a set one in query or store).
  private removeUnusedQueryParams = (
    validQueryParams: GlobalQueryParams,
  ): Partial<GlobalQueryParams> => {
    const usedGlobalProperties = {
      ...validQueryParams,
    };
    Object.keys(usedGlobalProperties).forEach((key) => {
      if (usedGlobalProperties[key as keyof GlobalQueryParams] === undefined) {
        delete usedGlobalProperties[key as keyof GlobalQueryParams];
      }
    });

    return usedGlobalProperties;
  };
}
